import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="example-promotion-codes"
export default class extends Controller {
  static targets = ["codeFormat", "examples"];

  connect() {
    this.url = this.element.dataset.url;
    this.codeFormatTarget.addEventListener(
      "input",
      this.updateExamples.bind(this),
    );
  }

  disconnect() {
    this.codeFormatTarget.removeEventListener(
      "input",
      this.updateExamples.bind(this),
    );
  }

  updateExamples() {
    const codeFormat = this.codeFormatTarget.value;

    if (this.debounceTimeout) {
      clearTimeout(this.debounceTimeout);
    }
    this.debounceTimeout = setTimeout(async () => {
      const params = new URLSearchParams({
        code_format: codeFormat,
      });
      const response = await fetch(`${this.url}?${params.toString()}`);
      const body = await response.text();
      this.examplesTarget.innerHTML = body;
    }, 300);
  }
}
